"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Platform = exports.Region = void 0;
var Region;
exports.Region = Region;

(function (Region) {
  Region["SG"] = "sg";
  Region["MY"] = "my";
  Region["TH"] = "th";
  Region["TWC"] = "twc";
  Region["PK"] = "pk";
  Region["AUE"] = "aue";
  Region["HK"] = "hk";
})(Region || (exports.Region = Region = {}));

var Platform;
exports.Platform = Platform;

(function (Platform) {
  Platform["WEB"] = "web";
  Platform["MWEB"] = "mweb";
})(Platform || (exports.Platform = Platform = {}));